(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('row-type', {
            parent: 'entity',
            url: '/row-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.rowType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-type/row-types.html',
                    controller: 'RowTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('row-type-detail', {
            parent: 'row-type',
            url: '/row-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.rowType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-type/row-type-detail.html',
                    controller: 'RowTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RowType', function($stateParams, RowType) {
                    return RowType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'row-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('row-type.new', {
            parent: 'row-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/row-type/row-type-dialog.html',
                    controller: 'RowTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('row-type.edit', {
            parent: 'row-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.rowType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-type/row-type-dialog.html',
                    controller: 'RowTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RowType', function($stateParams, RowType) {
                    return RowType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'row-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('row-type.delete', {
            parent: 'row-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/row-type/row-type-delete-dialog.html',
                    controller: 'RowTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['RowType', function(RowType) {
                            return RowType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('row-type', null, { reload: 'row-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
